<template>
  <div>
    <a-spin size="large" class="example" />
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
export default {
  data() {
    return {}
  },
  created() {
    this.init()
  },
  mounted() {},
  methods: {
    init() {
      var index = window.location.search.indexOf('=')
      var url = window.location.search.substr(index + 1)
      url = unescape(url)
      if (url.indexOf('?') != -1) {
        url = url.substr(0, url.indexOf('?'))
      }
      console.log(url, '地址')
      var token = getToken()
      console.log(token, '族库平台')
      // 动态创建一个不可见的iframe，在iframe中加载一个跨域HTML
      var iframe = document.createElement('iframe')
      iframe.src = url
      console.log(iframe, '2132312321')
      document.body.append(iframe)
      // 使用postMessage()方法将token传递给iframe
      setTimeout(function () {
        iframe.contentWindow.postMessage(token, url)
        // iframe.contentWindow.postMessage(
        //   {
        //     id: '1',
        //     oper: 'whole',
        //     token: token,
        //   },
        //   url
        // )
      }, 2000)
      setTimeout(function () {
        iframe.remove()
        window.location.href = url
      }, 3000)
    },
  },
}
</script>

<style lang="less" scoped>
.example {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>